import useInView from "@/lib/useInView";

/**
 * Reveal — wraps children and animates them into view on scroll.
 * Props:
 *   as        – element tag (default: "div")
 *   delay     – ms to wait before animating (supports staggered reveals)
 *   y         – translate Y distance when hidden (px)
 *   duration  – transition duration in ms
 *   className – extra classes
 *   once      – animate only once (default true)
 */
export default function Reveal({
  as: Tag = "div",
  delay = 0,
  y = 20,
  duration = 700,
  className = "",
  once = true,
  children,
  ...rest
}) {
  const [ref, inView] = useInView({ threshold: 0.15, once });

  const style = {
    transitionProperty: "opacity, transform",
    transitionDuration: `${duration}ms`,
    transitionTimingFunction: "cubic-bezier(0.22, 0.61, 0.36, 1)",
    transitionDelay: `${delay}ms`,
    opacity: inView ? 1 : 0,
    transform: inView ? "translate3d(0,0,0)" : `translate3d(0, ${y}px, 0)`,
    willChange: "opacity, transform",
  };

  return (
    <Tag ref={ref} style={style} className={className} {...rest}>
      {children}
    </Tag>
  );
}
